import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const list = props => {
  const { title, items, icon } = props;

  return (
    <div className="ui-list" role="tablist">
      <div className={'icon'}> { icon } </div>
        <div className={'title'}> { title } </div>
      <ul className={'items'}>
        { items.map( (item, key) => (
          <li className={'item'} key={key} dangerouslySetInnerHTML={{__html:item}}/>
        ))
        }
      </ul>
    </div>
  );
};

list.defaultProps = {
  icon: null,
  items: [],
};

list.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.array,
  icon: PropTypes.any,
};

export default list;
